import {Milliseconds} from "../constans/milliseconds";

const TIME_FOR_MESSAGE_TO_ARRIVE = 30 * Milliseconds.SECOND;

export const getThingCameraPresenceTimeout = () => {
    return 10 * Milliseconds.MINUTE - TIME_FOR_MESSAGE_TO_ARRIVE;
};

export const getStreamUrlTimeout = () => {
    return 5 * Milliseconds.MINUTE - TIME_FOR_MESSAGE_TO_ARRIVE;
};
